<ng-container *transloco="let t">
    <div class="sm:col-span-2 lg:col-span-1 flex flex-col flex-auto bg-card shadow rounded-t-2xl rounded-b-md">
        <div class="flex items-start justify-between m-6 mb-0">
            <div class="inline-flex">
                <div class="text-lg font-medium tracking-tight leading-6 truncate">{{ t(titleKey) }}</div>
                <form-field-tooltip *ngIf="currency"  style="float: none; height: 20px; display: auto; margin-left: 8px; align-self:auto;" tooltipTitleKey="analytics-revenue-disclaimer-title" tooltipKey="analytics-revenue-disclaimer"></form-field-tooltip>
            </div>
            <div *ngIf="selectablePeriods?.length" class="ml-2">
                <button
                    class="h-6 min-h-6 px-2 rounded-full bg-hover"
                    mat-button
                    [matMenuTriggerFor]="periodMenu">
                    <span class="font-medium text-sm text-secondary">{{selectedPeriod.isTranslationKey ? (selectedPeriod.label | transloco) : selectedPeriod.label}}</span>
                </button>
                <mat-menu #periodMenu="matMenu">
                    <button *ngFor="let item of selectablePeriods"
                            mat-menu-item
                            (click)="periodChanged(item)">
                        {{item.isTranslationKey ?  (item.label | transloco) : item.label}}
                    </button>
                </mat-menu>
            </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center mx-6 mt-3">
            <div class="text-5xl font-bold tracking-tighter leading-tight">{{finalTotalValue}}</div>
            <!--<div class="flex lg:flex-col lg:ml-3">
                <mat-icon
                    class="icon-size-5 text-red-500"
                    [svgIcon]="'heroicons_solid:trending-down'"></mat-icon>
                <div class="flex items-center ml-3 lg:ml-0 lg:mt-0.5 text-md leading-none whitespace-nowrap text-secondary">
                    <span class="font-medium text-red-500">2%</span>
                </div>
            </div>-->
        </div>
        <div class="flex flex-col flex-auto h-20">
            <apx-chart #lineGraph *ngIf="chartOptions"
                       class="w-full h-full"
                       [chart]="chartOptions.chart"
                       [colors]="chartOptions.colors"
                       [series]="chartOptions.series"
                       [stroke]="chartOptions.stroke"
                       [tooltip]="chartOptions.tooltip"
                       [xaxis]="chartOptions.xaxis"
                       [yaxis]="chartOptions.yaxis"></apx-chart>
        </div>
    </div>
</ng-container>
